export default function toSubscriptNumber(num: number): string {
  const subscriptDigits = '₀₁₂₃₄₅₆₇₈₉'
  return num
    .toString()
    .split('')
    .map((digit) => subscriptDigits[parseInt(digit, 10)])
    .join('')
}
